import { storage } from '../helpers';

export const RULETYPES = {
  SUMMARY: 1,
  DETAILED: 2,
  EMAIL: 4
};

export const notificationFormDataToRequest = (formData) => {
  return {
    'recipient': localStorage.getItem(storage.EMAIL_KEY),
    'rule_id': formData.ruleId,
    'rule_types': formData.ruleTypes,
    config: {
      'is_favorite': formData.isFavorite,
      'is_muted': formData.isMuted,
      'email_cron': formData.cron !== '' ?
        formData.cron :
        undefined,
      'triggered_by_filter': formData.triggeredBy.length !== 0 ?
        formData.triggeredBy :
        undefined
    }
  };
};


// WEBPACK FOOTER //
// src/helpers/notifications.js